<template>
    <ul class='my-tabs-component'>
        <li
            v-for="tab in tabs"
            :key="tab"
            @click="() => handleTabClick(tab)"
            :class="{'selected-tab': selectedTab === tab}"
        >
            {{ tab.charAt(0).toUpperCase() + tab.split('').splice(1, tab.length - 1).join('') }}
        </li>
    </ul>
</template>

<script>
export default {
    props: ['tabs', 'selectedTab', 'onChange'],
    name: 'myComponentTabNav',
    methods: {
        handleTabClick (tab) {
            if (this.onChange) {
                this.onChange(tab)
            }
        }
    }
}
</script>

<style scoped lang='scss'>
.my-tabs-component {
    $primary-dark: rgb(112, 174, 231);
    $border-size: 5px;
    margin: 0;
    margin-top: 18px;
    padding: 0;
    list-style-type: none;
    display: flex;
    li {
        user-select: none;
        cursor: pointer;
        padding: 8px 20px;
        border-bottom: none;
        background-color: $primary-dark;
        transition: background-color .1s;
        color: rgb(235, 235, 235);
        border-radius: 5px 5px 0 0;
        box-shadow: inset 0 -10px 12px rgba(31, 31, 31, 0.089);
        margin-right: 5px;
        &:hover {
            background-color: #81919c;
        }
        &.selected-tab {
            color: #000;
            box-shadow: none;
            font-weight: bold;
            margin-bottom: -$border-size;
            background-color: rgb(235, 235, 235);
        }
    }
}
</style>